const INTERNAL_PORTAL_ROLES = new Set(['superadmin', 'ops', 'support', 'finance']);

const PORTAL_GROUP_ORDER = ['aiKnowledge', 'userManagement'];

const PORTAL_GROUP_LABEL_KEYS = {
  aiKnowledge: 'nav_group_ai_knowledge',
  userManagement: 'nav_group_user_management',
};

export const isInternalPortalToolsEnabled = ({
  environment = process.env.REACT_APP_ENV,
  role,
} = {}) => (
  environment === 'development' || INTERNAL_PORTAL_ROLES.has((role || '').trim().toLowerCase())
);

export const filterPortalMenuItems = (items, entitlements, internalToolsEnabled) => (
  items.filter((item) => {
    if (item.key === 'marketplace') return false;
    if (item.internalOnly && !internalToolsEnabled) return false;
    if (item.requiresFeature && !entitlements?.[item.requiresFeature]) return false;
    return true;
  })
);

export const groupPortalMenuItems = (items) => {
  const groups = new Map();

  for (const item of items) {
    const groupKey = item.group;
    if (!groups.has(groupKey)) {
      groups.set(groupKey, {
        key: groupKey,
        labelKey: PORTAL_GROUP_LABEL_KEYS[groupKey] || `nav_group_${groupKey}`,
        items: [],
      });
    }
    groups.get(groupKey).items.push(item);
  }

  const orderedGroups = PORTAL_GROUP_ORDER.map((key) => groups.get(key)).filter(Boolean);
  for (const group of groups.values()) {
    if (!PORTAL_GROUP_ORDER.includes(group.key)) {
      orderedGroups.push(group);
    }
  }

  return orderedGroups;
};
